import classnames from 'classnames'

import { Icon } from '~/components/atoms/Icon/Icon'

import styles from './Arrow.module.css'

export interface ArrowProps {
  pointLeft?: boolean
}

export default function Arrow({ pointLeft = false }: ArrowProps) {
  return (
    <div className={classnames(styles.base, pointLeft && styles.pointLeft)}>
      <Icon type="Chevron" />
    </div>
  )
}
